/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { BudgetTab } from "~/components/Budgets";
import { useEnvironmentBudget } from "./hooks";

type Props = {
  envId: string;
};

export function EnvironmentBudgetTab({ envId }: Props) {
  const {
    createEnvironmentBudget,
    updateEnvironmentBudget,
    budget,
    forecast,
    spends,
    loading,
    error,
    year,
    setYear,
    getGeneratedBudget,
    isBudgetGenerated,
    reset,
  } = useEnvironmentBudget(envId);

  return (
    <BudgetTab
      budget={budget}
      spends={spends}
      forecast={forecast}
      year={year}
      onSetYear={setYear}
      onCreateBudget={createEnvironmentBudget}
      onEditBudget={updateEnvironmentBudget}
      loading={loading}
      error={error}
      onGetGeneratedBudget={getGeneratedBudget}
      isBudgetGenerated={isBudgetGenerated}
      onBudgetReset={reset}
    />
  );
}
